import React from 'react';
import './ProductosSubMenu.scss'
import { useNavigate } from "react-router-dom"
import { connect } from 'react-redux'
import { CollectionFilter } from '../filters/CollectionFilter'
import { setSelectedCategory, setProductsTable, setAllProducts, pushFilters, resetFilters, setPaginationState, showSpinner, setSelectedCollection } from '../actions'
import { getProducts } from '../hooks/gets';
import { CategoryFilter } from '../filters/CategoryFilter';
import { PreChangeBrandChosen } from '../hooks/config';
import { PopupOneButton } from './PopupOneButton';

const ProductosSubMenu = (props) => {
    const { menu, closeMenu, height, category, brandPreChosen = 'fansa', setShowPopupPresupuestosPendientes } = props
    const navigate = useNavigate();

    const handleClick = (path, item) => {
        props.showSpinner(true)
        changeBrandGlobal().then((brandPreChosen)=>{
          if(brandPreChosen == true){
              // if (props.productsTable !== 'allProducts') {
                  getProducts().then(async res => {
                      await props.setAllProducts(res)
                      configCategoryAndCollection(item, path)
                  }).catch(err => {
                      props.showSpinner(false)
                  })
              // } else {
              //     configCategoryAndCollection(item, path)
              // }
          }
        })
    }

    const changeBrandGlobal = () => {
      return new Promise(async (resolve)=>{
        let marcaCambiada = await PreChangeBrandChosen(brandPreChosen, props.budget)
        if(!marcaCambiada){
          setShowPopupPresupuestosPendientes(true)
          resolve(false)
        }else{
          resolve(true)
        }
      })
    }

    const configCategoryAndCollection = async (item, path) => {
        props.setPaginationState(1)
        props.setProductsTable('allProducts')
        const categoryFilter = new CategoryFilter(category.Name)
        await props.setSelectedCategory({
            categoryId: category.ID,
            subtitle: category.Name,
            img: category.ImgBanner,
            selectedCollection: ''
        })
        props.resetFilters()
        await props.pushFilters(categoryFilter)
        const collectionFilter = new CollectionFilter(item)
        props.pushFilters(collectionFilter)
        props.setSelectedCollection(item)
        closeMenu()
        navigate(path)
    }

    return (
        <div className="productos-submenu-container" style={{
            maxHeight: height
        }}>
            {
                (menu.length > 0) && menu.map((item, index) => {
                    return (
                        <div key={index} className="menu-item-container">
                            <div className="menu-item">
                                <div className="menu-item-text">
                                    <div onClick={() => handleClick(`/categoria/${props.selectedCategory}`, item)}>
                                        <p>{item[0].toUpperCase() + item.slice(1).toLowerCase()}</p>
                                    </div>
                                </div>
                            </div>
                        </div>)
                })
            }
        </div>
    )
}

const mapStateToProps = state => state

const mapDispatchToProps = {
    setSelectedCollection,
    setSelectedCategory,
    setProductsTable,
    setAllProducts,
    pushFilters,
    setPaginationState,
    resetFilters,
    showSpinner
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductosSubMenu)

// module.exports = { ProductosSubMenu: connect(mapStateToProps, mapDispatchToProps)(ProductosSubMenu) }